// Shared visual icons for a "mode card" — used on both the Play page's
// mode picker and the home page's play/learn grid, so the two never
// drift apart.

// Decorative "board preview" for each game mode — a couple of rows of
// lit/unlit cells at that mode's actual column count, evoking a few
// tiles already dropped rather than a literal chart. Purely visual
// (aria-hidden), so these patterns are just hand-picked to look good,
// not derived from anything.
export const PREVIEW_PATTERNS = {
  classic: [
    [1, 0, 1, 0, 1, 0, 0, 1],
    [0, 1, 0, 1, 0, 1, 1, 0],
  ],
  blitz: [
    [1, 0, 1, 1, 0, 1],
    [0, 1, 0, 1, 1, 0],
  ],
  challenge: [
    [1, 1, 1, 0, 0, 1, 1, 1],
    [0, 0, 0, 0, 0, 0, 0, 0],
  ],
};

// Challenge plays by stricter rules — flagged with a mono "Strict" label
// on the card (see mode-card__strict) rather than a second accent color,
// since rose is the system's only accent in normal use.
export const isStrictMode = (mode) => mode.matchStrategy === "exact";

export function ModeMiniGrid({ mode }) {
  return (
    <span
      className="mode-card__minigrid"
      style={{ gridTemplateColumns: `repeat(${mode.cols}, 10px)` }}
      aria-hidden="true"
    >
      {PREVIEW_PATTERNS[mode.id].flatMap((row, r) =>
        row.map((on, c) => (
          <span key={`${r}-${c}`} className={`mode-card__cell${on ? " on" : ""}`} />
        ))
      )}
    </span>
  );
}

// A little stack of flashcards for "Learn" — deliberately not a mini-grid,
// so it reads as a different kind of thing from the three game modes next
// to it at a glance.
export function LearnIcon() {
  return (
    <span className="mode-card__cardstack" aria-hidden="true">
      <span className="mode-card__cardstack-card mode-card__cardstack-card--back" />
      <span className="mode-card__cardstack-card mode-card__cardstack-card--front">Aa</span>
    </span>
  );
}
